import { FinanceRevenuesTable } from "components/Tables/FinanceRevenuesTable/FinanceRevenuesTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getFinanceHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/")({
    component: FinanceRevenuePage,
    staticData: {
        permissions: [],
        //permissions: [PermissionEnum.FinanceRevenueView],
        showInSideMenu: false,
        label: "pages.finance.revenue.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.finance.revenue.title"),
        };
    },
});

function FinanceRevenuePage() {
    return (
        <TenantPage headerNavigationItems={getFinanceHeaderItems}>
            <FinanceRevenuesTable />
        </TenantPage>
    );
}
